import React from "react";
import "./header.component.scoped.scss";
import {
  Button,
  Grid,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { history } from "react-router-guard";
import MenuIcon from '@material-ui/icons/Menu';

export default function HeaderComponent(props: any) {
  const [t] = useTranslation();

  function goBack() {
    if (history.location.pathname.includes('ratings') && props.buildingId) {
      history.push({
        pathname: '/scanning',
        search: `?id=${props.buildingId}`,
      });
      return;
    }
    if (history.location.pathname.includes('employee')) {
      history.push({
        pathname: '/employees',
      });
      return;
    }
    history.push({
      pathname: '/buildings',
    });
  }

  function openMenu() {
    const sidenav = document.querySelector(".main-nav");
    sidenav?.classList.toggle('show');
  }

  return (
    <header className={"main-header " + (props.mobView ? "mob-header" : "")} style={{minHeight: props.headerHeight ? props.headerHeight : "211px"}}>
      <div className="header-content">
        <Grid container direction="row" justify="space-between" alignItems="center">
          {props.layout === "half" && !props.mobView && (
            <Grid item xs={2} sm={1}>
              <div className="back-btn-container">
                <Button variant="outlined" onClick={goBack}>
                  <ArrowBackIosIcon style={{ fontSize: "0.7rem" }} />
                  Zurück
                </Button>
              </div>
            </Grid>
          )}
          {props.layout === "half" && props.mobView && (<div className="back-btn-mob">
            <Button onClick={goBack}>
              <ArrowBackIosIcon style={{ fontSize: "1rem" }} />
              Zurück
            </Button>
          </div>
          )}
          <Grid
            item
            xs={props.layout === "half" ? props.mobView ? 12 : 8 : 10}
            sm={props.layout === "half" ? props.mobView ? 12 : 10 : 11}
          >
            <div className={"info " + (props.centered || props.icon ? "centered" : "")}>
              {props.icon && (
                <div className={"main-icon " + (props.icon.includes('icons/') ? '' : 'full-width-img')}>
                  <img src={props.icon} alt=""/>
                </div>
              )}
              {props.title && (
                <div className="main-title">{t(props.title)}</div>
              )}
              {props.subtitle && (
                <div className="sub-title"> {t(props.subtitle)} </div>
              )}
              {props.mobtitle && (
                <div className="mob-title"> {t(props.mobtitle)} </div>
              )}
            </div>
          </Grid>
          {props.displayMenu && (
          <Grid container item xs={2} sm={1} direction="row" justify="flex-end">
            <div className="bar-menu" onClick={openMenu}>
              <MenuIcon />
            </div>
          </Grid>
          )}
          {props.displayLogo && (
          <Grid container item xs={2} sm={1} direction="row" justify="flex-end">
            <div className="logo">
              <img src="/profile.svg" alt="" />
            </div>
          </Grid>
          )}
        </Grid>
      </div>
      {props.children}
    </header>
  );
}
